var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3037 8.3021C8.69426 7.91162 9.32743 7.91168 9.71792 8.30224L16.0002 14.5857L22.285 8.3021C22.6756 7.91162 23.3088 7.91168 23.6993 8.30224C24.0897 8.6928 24.0897 9.32596 23.6991 9.71645L17.415 15.9993L23.6992 22.2835C24.0897 22.674 24.0897 23.3072 23.6992 23.6977C23.3087 24.0882 22.6755 24.0882 22.285 23.6977L16.0014 17.4142L9.71785 23.6977C9.32732 24.0882 8.69416 24.0882 8.30364 23.6977C7.91311 23.3072 7.91311 22.674 8.30364 22.2835L14.5866 16.0005L8.30357 9.71632C7.91308 9.32576 7.91314 8.69259 8.3037 8.3021Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelGrey);
export default __webpack_public_path__ + "static/media/cancel-grey.dda6acffee0143ba413ce9fd8807146b.svg";
export { ForwardRef as ReactComponent };